import { render } from "./ShopCouponsList.vue?vue&type=template&id=2d36b16b"
import script from "./ShopCouponsList.vue?vue&type=script&lang=js"
export * from "./ShopCouponsList.vue?vue&type=script&lang=js"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__